/**
 * ID of the admin role.
 */
export const ROLE_ADMIN_ID = 1;

/**
 * Admin of the user role.
 */
export const ROLE_USER_ID = 2;
